import React, { FC } from 'react';
import { useApplication } from '../../../../../../context/ApplicationContext';
import { Box, Typography } from '@mui/material';
import SummaryLine from '../../../../../../components/ui-component/form-component/abschluss-page/SummaryLine';

import Schema from '../../../../../../lib/paths/verwendungsnachweis_FULL_Paths.json';
import { get } from 'lodash';
import { DisplayEuro } from '../../../../../../utils/formats';
const P = Schema.attributes;

const AbschlussVN: FC<{}> = () => {
	const { application } = useApplication();

	return (
		<>
			<Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '1rem', mt: '1rem' }}>
				<Typography variant="h3"> Abschluss</Typography>

				<Typography>
					Überprüfen Sie noch einmal die wichtigsten Daten und folgen dann Schritten weiter unten um die Skizze einzureichen
				</Typography>

				<Box sx={{ width: '100%' }}>
					<Typography variant="h5"> Projektdaten</Typography>
					<SummaryLine
						label="Projekttitel:"
						value={get(application, P.Zuwendungsantrag.schema.attributes.Allgemein_Projekttitel.path, '')}
					/>

					<SummaryLine
						label="Beantragte Förderung:"
						value={DisplayEuro(
							get(application, P.Zuwendungsantrag.schema.attributes.Zusammenfassung_Foerdersumme_Geplant.path, ''),
						)}
					/>

					<SummaryLine
						label="Bewilligte Förderung:"
						value={DisplayEuro(
							get(application, P.Zuwendungsantrag.schema.attributes.Zusammenfassung_Foerdersumme_Bewilligt.path, ''),
						)}
					/>
				</Box>

				<Box sx={{ width: '100%' }}>
					<Typography variant="h5"> Verausgabt</Typography>
					<SummaryLine
						label="Gesamtausgaben:"
						value={DisplayEuro(get(application, P.Zusammenfassung_Gesamtausgaben.path, ''))}
					/>

					<SummaryLine
						label="Gesamteinnahmen:"
						value={DisplayEuro(get(application, P.Zusammenfassung_Gesamteinnahmen.path, ''))}
					/>

					<SummaryLine
						label="Gesamtkosten:"
						value={DisplayEuro(get(application, P.Zusammenfassung_Gesamtkosten.path, ''))}
					/>
				</Box>

				{get(application, P.Zusammenfassung_Anerkannte_Gesamtausgaben.path) && (
					<>
						{' '}
						<Box sx={{ width: '100%' }}>
							<Typography variant="h5"> Anerkannt</Typography>
							<SummaryLine
								label="Anerkannte Gesamtausgaben:"
								value={DisplayEuro(get(application, P.Zusammenfassung_Anerkannte_Gesamtausgaben.path, ''))}
							/>

							<SummaryLine
								label="Anerkannte Gesamteinnahmen:"
								value={DisplayEuro(get(application, P.Zusammenfassung_Anerkannte_Gesamteinnahmen.path, ''))}
							/>

							<SummaryLine
								label="Anerkannte Gesamtsumme:"
								value={DisplayEuro(get(application, P.Zusammenfassung_Anerkannte_Gesamtsumme.path, ''))}
							/>
						</Box>
					</>
				)}
			</Box>
		</>
	);
};
export default AbschlussVN;
